import { render, staticRenderFns } from "./ServiceOfferingCurrentYear.vue?vue&type=template&id=63bb4dc9&scoped=true"
import script from "./ServiceOfferingCurrentYear.vue?vue&type=script&lang=js"
export * from "./ServiceOfferingCurrentYear.vue?vue&type=script&lang=js"
import style0 from "./ServiceOfferingCurrentYear.vue?vue&type=style&index=0&id=63bb4dc9&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63bb4dc9",
  null
  
)

export default component.exports